import { cn } from "@/lib/utils";
import { Field } from "@base-ui/react/field";
import { Input as BaseUIInput, InputProps as BaseUIInputProps } from "@base-ui/react/input";
import Label from "../label";
import Description from "../description";
import FieldError from "../field-error";
import "./style.scss";

export interface InputProps extends Omit<BaseUIInputProps, "placeholder"> {
	label?: string;
	hideLabel?: boolean;
	description?: string | null;
	error?: string;
	placeholder?: string | number | null;
	containerClassName?: string;
}

const Input: React.FC<InputProps> = ({ label, hideLabel, description, error, placeholder, containerClassName, maxLength, ...props }) => {
	return (
		<Field.Root className={cn("flex flex-col items-start gap-2", containerClassName)}>
			{label && (
				<Label required={props.required} visible={!hideLabel}>
					{label}
				</Label>
			)}

			<BaseUIInput
				{...props}
				placeholder={placeholder?.toString() ?? undefined}
				className="ms-input w-full text-base focus:outline-2 focus:-outline-offset-1"
			/>

			{description && <Description>{description}</Description>}

			<FieldError
				message={error}
				values={{
					min: typeof props.minLength === "number" ? props.minLength : 0,
					max: typeof maxLength === "number" ? maxLength : 0,
				}}
			/>
		</Field.Root>
	);
};

export default Input;
